"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2890],{

/***/ 2890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zb": function() { return /* reexport */ form_Card; },
  "iz": function() { return /* reexport */ form_Divider; },
  "nv": function() { return /* reexport */ form_Paragraph; },
  "Dx": function() { return /* reexport */ form_Title; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(5444);
// EXTERNAL MODULE: ./_constants/theme.js
var theme = __webpack_require__(7579);
// EXTERNAL MODULE: ./_components/atomic/Icon/index.jsx + 49 modules
var Icon = __webpack_require__(6668);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./_components/atomic/layouts/form/Title/index.jsx


var _excluded = ["noBottomSpace"],
    _excluded2 = ["color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var colors = theme/* theme.colors */.r.colors,
    fontSizes = theme/* theme.fontSizes */.r.fontSizes,
    spaces = theme/* theme.spaces */.r.spaces; // eslint-disable-next-line prettier/prettier, react/display-name

var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var noBottomSpace = _ref.noBottomSpace,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "Title__StyledTitle",
  componentId: "sc-18x8j0y-0"
})(["display:flex;justify-content:space-between;align-items:center;margin-bottom:", "px;", ""], spaces.medium, function (_ref2) {
  var noBottomSpace = _ref2.noBottomSpace;
  return noBottomSpace && (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:0;"]);
});
var StyledBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Title__StyledBody",
  componentId: "sc-18x8j0y-1"
})(["font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:500;color:", ";"], fontSizes.large2X, colors.gray[800]);
var StyledAction = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Title__StyledAction",
  componentId: "sc-18x8j0y-2"
})(["display:flex;justify-content:flex-end;cursor:pointer;"]); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledActionText = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref3, ref) {
  var color = _ref3.color,
      props = (0,objectWithoutProperties/* default */.Z)(_ref3, _excluded2);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "Title__StyledActionText",
  componentId: "sc-18x8j0y-3"
})(["font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:500;color:", ";"], fontSizes.regular, function (_ref4) {
  var color = _ref4.color;
  return color;
});
var StyledIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Title__StyledIconContainer",
  componentId: "sc-18x8j0y-4"
})(["display:flex;margin-left:", "px;"], spaces.small - 2);

var Title = function Title(_ref5) {
  var noBottomSpace = _ref5.noBottomSpace,
      action = _ref5.action,
      children = _ref5.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledTitle, {
    noBottomSpace: noBottomSpace,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledBody, {
      children: children
    }), action && /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledAction, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledActionText, {
        color: (action === null || action === void 0 ? void 0 : action.textColor) || colors.blue[500],
        children: action === null || action === void 0 ? void 0 : action.text
      }), (action === null || action === void 0 ? void 0 : action.iconAlias) && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIconContainer, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
          alias: action === null || action === void 0 ? void 0 : action.iconAlias,
          color: (action === null || action === void 0 ? void 0 : action.iconColor) || colors.blue[500]
        })
      })]
    })]
  });
};

/* harmony default export */ var form_Title = (Title);
;// CONCATENATED MODULE: ./_components/atomic/layouts/form/Paragraph/index.jsx


var Paragraph_excluded = ["bold", "color", "noBottomSpace"];

function Paragraph_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Paragraph_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Paragraph_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Paragraph_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Paragraph_colors = theme/* theme.colors */.r.colors,
    Paragraph_fontSizes = theme/* theme.fontSizes */.r.fontSizes,
    Paragraph_spaces = theme/* theme.spaces */.r.spaces; // eslint-disable-next-line prettier/prettier, react/display-name

var StyledParagraph = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var bold = _ref.bold,
      color = _ref.color,
      noBottomSpace = _ref.noBottomSpace,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Paragraph_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", Paragraph_objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "Paragraph__StyledParagraph",
  componentId: "sc-at9puu-0"
})(["margin-bottom:", "px;font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:400;color:", ";", " ", ""], Paragraph_spaces.medium, Paragraph_fontSizes.regular, function (_ref2) {
  var color = _ref2.color;
  return color;
}, function (_ref3) {
  var bold = _ref3.bold;
  return bold && (0,styled_components_browser_esm/* css */.iv)(["font-weight:500;"]);
}, function (_ref4) {
  var noBottomSpace = _ref4.noBottomSpace;
  return noBottomSpace && (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:0;"]);
});

var Paragraph = function Paragraph(_ref5) {
  var children = _ref5.children,
      bold = _ref5.bold,
      color = _ref5.color,
      noBottomSpace = _ref5.noBottomSpace;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledParagraph, {
    bold: bold,
    color: color || Paragraph_colors.gray[800],
    noBottomSpace: noBottomSpace,
    children: children
  });
};

/* harmony default export */ var form_Paragraph = (Paragraph);
;// CONCATENATED MODULE: ./_components/atomic/layouts/form/Card/Body/index.jsx


var Body_StyledBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Body__StyledBody",
  componentId: "sc-druo3f-0"
})([""]);

var Body = function Body(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Body_StyledBody, {
    children: children
  });
};

/* harmony default export */ var Card_Body = (Body);
;// CONCATENATED MODULE: ./_components/atomic/layouts/form/Card/Divider/index.jsx



var Divider_colors = theme/* theme.colors */.r.colors,
    Divider_spaces = theme/* theme.spaces */.r.spaces;
var StyledDivider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Divider__StyledDivider",
  componentId: "sc-e1jol-0"
})(["height:1px;margin-bottom:", "px;background:", ";"], Divider_spaces.regular, Divider_colors.gray[200]);

var Divider = function Divider() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledDivider, {});
};

/* harmony default export */ var Card_Divider = (Divider);
;// CONCATENATED MODULE: ./_components/atomic/layouts/form/Card/Text/index.jsx


var Text_excluded = ["bold", "color", "noBottomSpace"];

function Text_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Text_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Text_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Text_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var Text_colors = theme/* theme.colors */.r.colors,
    Text_fontSizes = theme/* theme.fontSizes */.r.fontSizes,
    Text_spaces = theme/* theme.spaces */.r.spaces; // eslint-disable-next-line prettier/prettier, react/display-name

var StyledText = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var bold = _ref.bold,
      color = _ref.color,
      noBottomSpace = _ref.noBottomSpace,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Text_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", Text_objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "Text__StyledText",
  componentId: "sc-4ajhkp-0"
})(["margin-bottom:", "px;font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:400;color:", ";span{color:", ";}", " ", ""], Text_spaces.regular, Text_fontSizes.regular, function (_ref2) {
  var color = _ref2.color;
  return color;
}, Text_colors.orange[500], function (_ref3) {
  var bold = _ref3.bold;
  return bold && (0,styled_components_browser_esm/* css */.iv)(["font-weight:500;"]);
}, function (_ref4) {
  var noBottomSpace = _ref4.noBottomSpace;
  return noBottomSpace && (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:", "px;"], Text_spaces.small2X);
});

var Text = function Text(_ref5) {
  var children = _ref5.children,
      bold = _ref5.bold,
      color = _ref5.color,
      required = _ref5.required,
      noBottomSpace = _ref5.noBottomSpace;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledText, {
    bold: bold,
    color: color || Text_colors.gray[800],
    noBottomSpace: noBottomSpace,
    children: [children, required && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "\xA0*"
    })]
  });
};

/* harmony default export */ var Card_Text = (Text);
;// CONCATENATED MODULE: ./_components/atomic/layouts/form/Card/Title/index.jsx


var Title_excluded = ["withAction"],
    Title_excluded2 = ["color"];

function Title_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Title_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Title_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Title_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var Title_colors = theme/* theme.colors */.r.colors,
    devices = theme/* theme.devices */.r.devices,
    Title_fontSizes = theme/* theme.fontSizes */.r.fontSizes,
    Title_spaces = theme/* theme.spaces */.r.spaces; // eslint-disable-next-line prettier/prettier, react/display-name

var Title_StyledTitle = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var withAction = _ref.withAction,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Title_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", Title_objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "Title__StyledTitle",
  componentId: "sc-kkwrrn-0"
})(["display:flex;justify-content:space-between;align-items:center;margin-bottom:", "px;@media ", "{", "}"], Title_spaces.regular, devices.tablet, function (_ref2) {
  var withAction = _ref2.withAction;
  return withAction && (0,styled_components_browser_esm/* css */.iv)(["position:relative;padding-top:", "px;"], Title_spaces.large3X);
});
var Title_StyledBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Title__StyledBody",
  componentId: "sc-kkwrrn-1"
})(["font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:500;color:", ";@media ", "{font-size:", "px;}"], Title_fontSizes.large, Title_colors.gray[800], devices.tablet, Title_fontSizes.regular);
var Title_StyledAction = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Title__StyledAction",
  componentId: "sc-kkwrrn-2"
})(["display:flex;justify-content:flex-end;cursor:pointer;@media ", "{position:absolute;top:0;right:0;}"], devices.tablet); // eslint-disable-next-line prettier/prettier, react/display-name

var Title_StyledActionText = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref3, ref) {
  var color = _ref3.color,
      props = (0,objectWithoutProperties/* default */.Z)(_ref3, Title_excluded2);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", Title_objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "Title__StyledActionText",
  componentId: "sc-kkwrrn-3"
})(["font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:500;color:", ";"], Title_fontSizes.regular, function (_ref4) {
  var color = _ref4.color;
  return color;
});
var Title_StyledIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Title__StyledIconContainer",
  componentId: "sc-kkwrrn-4"
})(["display:flex;margin-left:", "px;"], Title_spaces.small - 2);

var Title_Title = function Title(_ref5) {
  var action = _ref5.action,
      children = _ref5.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Title_StyledTitle, {
    withAction: Boolean(action),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title_StyledBody, {
      children: children
    }), action && /*#__PURE__*/(0,jsx_runtime.jsxs)(Title_StyledAction, {
      onClick: action === null || action === void 0 ? void 0 : action.onClick,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title_StyledActionText, {
        color: (action === null || action === void 0 ? void 0 : action.textColor) || Title_colors.blue[500],
        children: action === null || action === void 0 ? void 0 : action.text
      }), (action === null || action === void 0 ? void 0 : action.iconAlias) && /*#__PURE__*/(0,jsx_runtime.jsx)(Title_StyledIconContainer, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
          alias: action === null || action === void 0 ? void 0 : action.iconAlias,
          color: (action === null || action === void 0 ? void 0 : action.iconColor) || Title_colors.blue[500]
        })
      })]
    })]
  });
};

/* harmony default export */ var Card_Title = (Title_Title);
;// CONCATENATED MODULE: ./_components/atomic/layouts/form/Card/index.jsx


var Card_excluded = ["noBorder", "bottomSpace", "topSpace", "noInnerSpace"];

function Card_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Card_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Card_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Card_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var Card_colors = theme/* theme.colors */.r.colors,
    Card_devices = theme/* theme.devices */.r.devices,
    Card_spaces = theme/* theme.spaces */.r.spaces; // eslint-disable-next-line prettier/prettier, react/display-name

var StyledCard = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var noBorder = _ref.noBorder,
      bottomSpace = _ref.bottomSpace,
      topSpace = _ref.topSpace,
      noInnerSpace = _ref.noInnerSpace,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Card_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", Card_objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "Card__StyledCard",
  componentId: "sc-1pi1oc2-0"
})(["padding:", "px;background:", ";border:1px solid ", ";border-radius:16px;", " ", " ", " ", " @media ", "{padding:", "px;", "}"], Card_spaces.medium, Card_colors.white, Card_colors.gray[200], function (_ref2) {
  var noBorder = _ref2.noBorder;
  return noBorder && (0,styled_components_browser_esm/* css */.iv)(["border:none;"]);
}, function (_ref3) {
  var noInnerSpace = _ref3.noInnerSpace;
  return noInnerSpace && (0,styled_components_browser_esm/* css */.iv)(["padding:0;"]);
}, function (_ref4) {
  var bottomSpace = _ref4.bottomSpace;
  return bottomSpace && (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:", "px;"], Card_spaces.medium);
}, function (_ref5) {
  var topSpace = _ref5.topSpace;
  return topSpace && (0,styled_components_browser_esm/* css */.iv)(["margin-top:", "px;"], Card_spaces.medium);
}, Card_devices.tablet, Card_spaces.regular, function (_ref6) {
  var noInnerSpace = _ref6.noInnerSpace;
  return noInnerSpace && (0,styled_components_browser_esm/* css */.iv)(["padding:0;"]);
});

var Card = function Card(_ref7) {
  var noBorder = _ref7.noBorder,
      bottomSpace = _ref7.bottomSpace,
      topSpace = _ref7.topSpace,
      noInnerSpace = _ref7.noInnerSpace,
      children = _ref7.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCard, {
    noBorder: noBorder,
    bottomSpace: bottomSpace,
    topSpace: topSpace,
    noInnerSpace: noInnerSpace,
    children: children
  });
};

Card.Divider = Card_Divider;
Card.Body = Card_Body;
Card.Text = Card_Text;
Card.Title = Card_Title;
/* harmony default export */ var form_Card = (Card);
;// CONCATENATED MODULE: ./_components/atomic/layouts/form/Divider/index.jsx


var Divider_excluded = ["desktop", "mobile", "size"];

function Divider_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Divider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Divider_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Divider_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Divider_devices = theme/* theme.devices */.r.devices,
    form_Divider_spaces = theme/* theme.spaces */.r.spaces; // eslint-disable-next-line prettier/prettier, react/display-name

var Divider_StyledDivider = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var desktop = _ref.desktop,
      mobile = _ref.mobile,
      size = _ref.size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Divider_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", Divider_objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "Divider__StyledDivider",
  componentId: "sc-i82f28-0"
})(["height:", "px;width:100%;", " ", " @media ", "{", " ", "}"], form_Divider_spaces.regular, function (_ref2) {
  var size = _ref2.size;
  return size && (0,styled_components_browser_esm/* css */.iv)(["height:", "px;"], size);
}, function (_ref3) {
  var mobile = _ref3.mobile;
  return mobile && (0,styled_components_browser_esm/* css */.iv)(["height:0;"]);
}, Divider_devices.tablet, function (_ref4) {
  var desktop = _ref4.desktop;
  return desktop && (0,styled_components_browser_esm/* css */.iv)(["height:0;"]);
}, function (_ref5) {
  var mobile = _ref5.mobile,
      size = _ref5.size;
  return mobile && size && (0,styled_components_browser_esm/* css */.iv)(["height:", "px;"], size);
});

var Divider_Divider = function Divider(_ref6) {
  var size = _ref6.size,
      desktop = _ref6.desktop,
      mobile = _ref6.mobile;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Divider_StyledDivider, {
    size: size,
    desktop: desktop,
    mobile: mobile
  });
};

/* harmony default export */ var form_Divider = (Divider_Divider);
;// CONCATENATED MODULE: ./_components/atomic/layouts/form/index.js






/***/ })

}]);